import React, { memo } from "react";
import { NodeResizer } from "@xyflow/react";

/**
 * GroupNode — Container visual para agrupar nodes no canvas.
 * Nao executavel. Apenas organizacao visual.
 *
 * data.label: string — nome do grupo
 * data.groupColor: string — cor do grupo (hex ou preset key)
 * data.collapsed: boolean — se o grupo esta colapsado (futuro)
 */
const GROUP_COLORS = {
  blue:   { bg: "rgba(59,130,246,0.08)",  border: "#3b82f6",  text: "#1e40af" },
  green:  { bg: "rgba(34,197,94,0.08)",   border: "#22c55e",  text: "#166534" },
  purple: { bg: "rgba(139,92,246,0.08)",  border: "#8b5cf6",  text: "#5b21b6" },
  orange: { bg: "rgba(249,115,22,0.08)",  border: "#f97316",  text: "#9a3412" },
  pink:   { bg: "rgba(236,72,153,0.08)",  border: "#ec4899",  text: "#9d174d" },
  gray:   { bg: "rgba(107,114,128,0.08)", border: "#6b7280",  text: "#374151" },
  red:    { bg: "rgba(239,68,68,0.08)",   border: "#ef4444",  text: "#991b1b" },
  teal:   { bg: "rgba(20,184,166,0.08)",  border: "#14b8a6",  text: "#115e59" },
};

const GroupNode = memo(({ id, data, selected }) => {
  const label = data?.label || "Grupo";
  const colorKey = data?.groupColor || "blue";
  const palette = GROUP_COLORS[colorKey] || GROUP_COLORS.blue;

  return (
    <div
      style={{
        backgroundColor: palette.bg,
        border: `2px ${selected ? "solid" : "dashed"} ${selected ? palette.border : palette.border + "80"}`,
        borderRadius: 12,
        padding: "8px 12px 12px 12px",
        minWidth: 300,
        minHeight: 200,
        width: "100%",
        height: "100%",
        position: "relative",
        transition: "border-color 0.2s, box-shadow 0.2s",
        boxShadow: selected
          ? `0 0 0 2px ${palette.border}30, inset 0 0 0 1px ${palette.border}20`
          : `inset 0 0 0 1px ${palette.border}10`,
      }}
    >
      {/* Resizer — permite redimensionar o grupo */}
      <NodeResizer
        color={palette.border}
        isVisible={selected}
        minWidth={300}
        minHeight={200}
        lineStyle={{ borderWidth: 2 }}
        handleStyle={{
          width: 10,
          height: 10,
          borderRadius: 3,
          backgroundColor: palette.border,
          border: "2px solid white",
        }}
      />

      {/* Header do grupo */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          marginBottom: 4,
          pointerEvents: "none",
          userSelect: "none",
        }}
      >
        {/* Dot indicador */}
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: palette.border,
            flexShrink: 0,
          }}
        />
        {/* Label */}
        <span
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: palette.text,
            letterSpacing: "-0.01em",
            textTransform: "uppercase",
            opacity: 0.8,
          }}
        >
          {label}
        </span>
      </div>
    </div>
  );
});

GroupNode.displayName = "GroupNode";
export { GROUP_COLORS };
export default GroupNode;
